import { render, staticRenderFns } from "./PlanificacioNavGlobals.vue?vue&type=template&id=f40bca1c&"
import script from "./PlanificacioNavGlobals.vue?vue&type=script&lang=js&"
export * from "./PlanificacioNavGlobals.vue?vue&type=script&lang=js&"
import style0 from "./PlanificacioNavGlobals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VDivider,VIcon,VImg,VSubheader,VTreeview})
